// extracted by mini-css-extract-plugin
export default {"link":"link__g5qWrX_L","title":"title__XtYBMQhG","name":"name__svu5nddd"};